import searchLogo from "../assets/images/searchLogo.svg";
import TickerHyperLinkComponent from "../components/TickerHyperLinkComponent";
import {
  dateFormatterForGrid,
  myValueFormatter,
  myValueFormatter_quantity,
  rateFormatter,
} from "./commonFunctions";
import { dtcStatusColors , status} from "./constants";
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-balham.css';

export const AllocationColumnDefs = [

  {
    headerName: "Returns Id",
    field: "returns_id",
    floatingFilter: false,
    filter: "agSetColumnFilter",
    editable: false,
    hide: true,
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: function (params: any) {
      return {
        display: "flex",
        alignItems: "center",
        borderRight: "0.5px solid #E1E1E1",
      };
    },
    minWidth: 95,
    maxWidth: 95,
    suppressSizeToFit: false,
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
  },
  {
    headerName: "Activity Id",
    field: "activity_id",
    floatingFilter: false,
    filter: "agSetColumnFilter",
    editable: false,
    hide: true,
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: {
      display: "flex",
      alignItems: "center",
      borderRight: "1px solid #DFDFDF",
    },
    minWidth: 90,
    maxWidth: 100,
    suppressSizeToFit: false,
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
  },
  {
    headerName: "Contract",
    field: "contract_id",
    floatingFilter: false,
    filter: "agSetColumnFilter",
    editable: false,
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: function (params: any) {
      return {
        display: "flex",
        alignItems: "center",
        borderRight: "0.5px solid #E1E1E1",
        borderLeft: "0.5px solid #E1E1E1",
      };
    },
    minWidth: 85,
    maxWidth: 100,
    suppressSizeToFit: false,
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
  },
  {
    headerName: "B/L",
    field: "bl",
    floatingFilter: false,
    filter: "agSetColumnFilter",
    editable: false,
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: function (params: any) {
      return {
        display: "flex",
        alignItems: "center",
        borderRight: "0.5px solid #E1E1E1",
      };
    },
    minWidth: 55,
    maxWidth: 70,
    suppressSizeToFit: false,
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
  },
  {
    headerName: "Cpty Id",
    field: "cpty_id",
    floatingFilter: false,
    filter: "agSetColumnFilter",
    editable: false,
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: function (params: any) {
      return {
        display: "flex",
        alignItems: "center",
        borderRight: "0.5px solid #E1E1E1",
      };
    },
    minWidth: 75,
    maxWidth: 100,
    suppressSizeToFit: false,
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
  },
  {
    headerName: "Ticker",
    field: "ticker",
    floatingFilter: false,
    filter: "agSetColumnFilter",
    editable: false,
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: function (params: any) {
      return {
        display: "flex",
        alignItems: "center",
        borderRight: "0.5px solid #E1E1E1",
      };
    },
    minWidth: 70,
    maxWidth: 100,
    suppressSizeToFit: false,
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
    cellRenderer: TickerHyperLinkComponent
  },
  {
    headerName: "Cusip",
    field: "sec_id",
    floatingFilter: false,
    filter: "agSetColumnFilter",
    editable: false,
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: function (params: any) {
      return {
        display: "flex",
        alignItems: "center",
        borderRight: "0.5px solid #E1E1E1",
      };
    },
    minWidth: 80,
    maxWidth: 80,
    suppressSizeToFit: false,
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
  },
  {
    headerName: "SODQty",
    field: "sod_quantity",
    type: "rightAligned",
    floatingFilter: false,
    editable: false,
    filter: "agNumberColumnFilter",
    valueFormatter: myValueFormatter_quantity,
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: function (params: any) {
      return {
        display: "flex",
        alignItems: "center",
        borderRight: "0.5px solid #E1E1E1",
        justifyContent: "flex-end",
      };
    },
    minWidth: 80,
    maxWidth: 130,
    suppressSizeToFit: false,
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
  },
  {
    headerName: "ContraQty",
    field: "borrow_quantity",
    type: "rightAligned",
    floatingFilter: false,
    editable: false,
    filter: "agNumberColumnFilter",
    valueFormatter: myValueFormatter_quantity,
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: function (params: any) {
      return {
        display: "flex",
        alignItems: "center",
        borderRight: "0.5px solid #E1E1E1",
        justifyContent: "flex-end",
      };
    },
    minWidth: 88,
    maxWidth: 130,
    suppressSizeToFit: false,
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
  },
  {
    headerName: "Borrow Val",
    type: "rightAligned",
    field: "borrow_amt",
    floatingFilter: false,
    editable: false,
    hide: true,
    filter: "agNumberColumnFilter",
    valueFormatter: myValueFormatter,
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: function (params: any) {
      return {
        display: "flex",
        alignItems: "center",
        borderRight: "0.5px solid #E1E1E1",
        justifyContent: "flex-end",
      };
    },
    minWidth: 120,
    maxWidth: 160,
    suppressSizeToFit: false,
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
  },
  {
    headerName: "Rate",
    field: "rate",
    floatingFilter: false,
    editable: false,
    type: "rightAligned",
    filter: "agNumberColumnFilter",
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: function (params: any) {
      return {
        display: "flex",
        alignItems: "center",
        borderRight: "0.5px solid #E1E1E1",
        justifyContent: "flex-end",
      };
    },
    minWidth: 60,
    maxWidth: 90,
    suppressSizeToFit: false,
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
    valueFormatter: rateFormatter
  },
  
  {
    field: 'isAllocated',
    headerName: 'IsAlloc',
    pinned: 'right',
    minWidth: 70,
    maxWidth: 90,
    cellStyle: function (params: any) {
      return {
        display: "flex",
        alignItems: "center",
        borderRight: "0.5px solid #E1E1E1",
      };
    },
    icons: {
      menu: `<img src="${searchLogo}" />`,
    }
  },
  {
    headerName: "",
    field: "isSelect",
    floatingFilter: false,
    floatingFilterComponentParams: { suppressFilterButton: true },
    headerCheckboxSelection: true,
    showDisabledCheckboxes: true,
    checkboxSelection: true,
    editable: false,
    cellStyle: {
      display: "flex",
      alignItems: "center",
      borderRight: "0.5px solid #E1E1E1",
    },
    pinned: "left",
    lockPinned: true,
    cellClass: "lock-pinned",
    tooltipField: "isFullyReturned",
    tooltipComponentParams: function(params: any){
      if(params?.node?.data?.isFullyReturned){
        return {
          message: 'Contract is fully returned',
        };
      }
    },
    //cellRendererParams:disableParamsFunction,
    minWidth: 70,
    maxWidth: 90,
    suppressSizeToFit: false,
  },
  {
    headerName: "RtnQty",
    field: "return_quantity",
    type: "rightAligned",
    floatingFilter: false,
    editable: false,
    filter: "agNumberColumnFilter",
    valueFormatter: myValueFormatter_quantity,
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: function (params: any) {
      return {
        display: "flex",
        alignItems: "center",
        borderRight: "0.5px solid #E1E1E1",
        justifyContent: "flex-end",
      };
    },
    minWidth: 80,
    maxWidth: 150,
    suppressSizeToFit: false,
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
  },
  {
    headerName: "RemainQty",
    field: "remain_qty",
    aggFunc: 'sum',
    type: "rightAligned",
    floatingFilter: false,
    editable: false,
    filter: "agNumberColumnFilter",
    valueFormatter: myValueFormatter_quantity,
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: function (params: any) {
      return {
        display: "flex",
        alignItems: "center",
        borderRight: "0.5px solid #E1E1E1",
        justifyContent: "flex-end",
      };
    },
    minWidth: 95,
    maxWidth: 150,
    suppressSizeToFit: false,
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
  },
  {
    field: 'isBuyIn',
    headerName: 'IsBuyIn',
    minWidth: 75,
    maxWidth: 90,
    cellRendererParams: {
      disabled: true,
    },
    cellStyle: function (params: any) {
      return {
        display: "flex",
        alignItems: "center",
        borderRight: "0.5px solid #E1E1E1",
      };
    },
    icons: {
      menu: `<img src="${searchLogo}" />`,
    }
  },
  {
    headerName: "Return Val",
    type: "rightAligned",
    field: "return_amt",
    floatingFilter: false,
    editable: false,
    hide: true,
    filter: "agNumberColumnFilter",
    valueFormatter: myValueFormatter,
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: function (params: any) {
      return {
        display: "flex",
        alignItems: "center",
        borderRight: "0.5px solid #E1E1E1",
        justifyContent: "flex-end",
      };
    },
    minWidth: 100,
    maxWidth: 150,
    suppressSizeToFit: false,
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
  },
  {
    headerName: "DtcStatus",
    field: "return_dtc_status",
    floatingFilter: false,
    filter: "agSetColumnFilter",
    editable: false,
    pinned: 'right',
    lockPinned: true,
    cellClass: "lock-pinned",
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: function (params: any) {
      if (params?.data?.return_dtc_status?.toLowerCase() === "settled") {
        return {
          display: "flex",
          alignItems: "center",
          borderRight: "0.5px solid #E1E1E1",
          backgroundColor: dtcStatusColors.settled
        };
      }
      if (params?.data?.return_dtc_status?.toLowerCase() === "pended") {
        return {
          display: "flex",
          alignItems: "center",
          borderRight: "0.5px solid #DFDFDF",
          backgroundColor: dtcStatusColors.pended
        };
      } if (params?.data?.return_dtc_status?.toLowerCase() === "rad") {
        return {
          display: "flex",
          alignItems: "center",
          borderRight: "0.5px solid #DFDFDF",
          backgroundColor: dtcStatusColors.RAD
        };
      } if (params?.data?.return_dtc_status?.toLowerCase() === "approved") {
        return {
          display: "flex",
          alignItems: "center",
          borderRight: "0.5px solid #DFDFDF",
          backgroundColor: dtcStatusColors.approved
        };
      } if (params?.data?.return_dtc_status?.toLowerCase() === "reversed") {
        return {
          display: "flex",
          alignItems: "center",
          borderRight: "0.5px solid #DFDFDF",
          backgroundColor: dtcStatusColors.reversed
        };
      } if (params?.data?.return_dtc_status?.toLowerCase() === "dropped") {
        return {
          display: "flex",
          alignItems: "center",
          borderRight: "0.5px solid #DFDFDF",
          backgroundColor: dtcStatusColors.dropped
        };
      } if (params?.data?.return_dtc_status?.toLowerCase() === "non-ccf") {
        return {
          display: "flex",
          alignItems: "center",
          borderRight: "0.5px solid #DFDFDF",
          backgroundColor: dtcStatusColors.nonCcf
        };
      } if (params?.data?.return_dtc_status?.toLowerCase() === "canceled") {
        return {
          display: "flex",
          alignItems: "center",
          borderRight: "0.5px solid #DFDFDF",
          backgroundColor: dtcStatusColors.canceled
        };
      } else {
        return {
          display: "flex",
          alignItems: "center",
          borderRight: "0.5px solid #DFDFDF",
        };
      }
    },
    minWidth: 90,
    maxWidth: 140,
    suppressSizeToFit: false,
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
  },
  {
    headerName: "LnetStatus",
    field: "processing_status",
    floatingFilter: false,
    filter: "agSetColumnFilter",
    editable: false,
    pinned: "right",
    icons: {
      menu: `<img src="${searchLogo}" />`,

    },
    floatingFilterComponentParams: { suppressFilterButton: true },
    minWidth: 95,
    maxWidth: 120,
    cellStyle: function (params: any) {
      if (params?.node?.data?.processing_status === "Error") {
        return {
          display: "flex",
          alignItems: "center",
          color: "#E90909",
          borderRight: "0.5px solid #E1E1E1",
        };
      }
      else if (params?.node?.data?.processing_status === "Pending") {
        return {
          display: "flex",
          alignItems: "center",
          backgroundColor: status.sent,
        };
      }
       else {
        return {
          display: "flex",
          alignItems: "center",
          borderRight: "0.5px solid #E1E1E1",
        };
      }
    },
  },
  {
    headerName: "Comments",
    field: "comments",
    floatingFilter: false,
    filter: "agTextColumnFilter",
    editable: false,
    pinned: "right",
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
    tooltipField: "comments",
    floatingFilterComponentParams: { suppressFilterButton: true },
    minWidth: 100,
    maxWidth: 300,
    tooltipComponentParams: function(params: any){
      return {
        message: params?.node?.data?.comments,
      }; 
    },
    cellStyle: function (params: any) {
      return {
        display: "flex",
        alignItems: "center",
        borderRight: "0.5px solid #E1E1E1",
      };
    },
    resizable: true
  },
  {
    headerName: "Is Fully Returned",
    field: "isFullyReturned",
    floatingFilter: false,
    filter: "agSetColumnFilter",
    editable: false,
    pinned: 'right',
    hide: true,
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: function (params: any) {
        return {
          display: "flex",
          alignItems: "center",
          borderRight: "0.5px solid #DFDFDF",
        };
    },
    minWidth: 110,
    maxWidth: 140,
    suppressSizeToFit: false,
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
  },
  {
    headerName: "Return Update By",
    field: "return_updated_by",
    floatingFilter: false,
    editable: false,
    hide: true,
    filter: "agSetColumnFilter",
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: function (params: any) {
      return {
        display: "flex",
        alignItems: "center",
        borderRight: "0.5px solid #E1E1E1",
      };
    },
    minWidth: 135,
    maxWidth: 135,
    suppressSizeToFit: false,
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
  },
  {
    headerName: "Return Update Date",
    field: "returnUpdatedDate",
    floatingFilter: false,
    editable: false,
    filter: "agSetColumnFilter",
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: function (params: any) {
      return {
        display: "flex",
        alignItems: "center",
        borderRight: "0.5px solid #E1E1E1",
      };
    },
    minWidth: 135,
    maxWidth: 135,
    suppressSizeToFit: false,
     valueFormatter: dateFormatterForGrid,
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
  },
];